import { render } from "./MainContent.vue?vue&type=template&id=548d91d8&scoped=true"
import script from "./MainContent.vue?vue&type=script&lang=js"
export * from "./MainContent.vue?vue&type=script&lang=js"

import "./MainContent.vue?vue&type=style&index=0&id=548d91d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548d91d8"]])

export default __exports__